module.exports = __webpack_public_path__ + "static/img/download-on-the-app-store-logo.6608af8.png";


//////////////////
// WEBPACK FOOTER
// ./static/download-app/download-on-the-app-store-logo.png
// module id = 1341
// module chunks = 0